/* ==========================================================================
   Graphics kit cart helpers (Moeed Builds, v2)
   - Removing a kit removes its linked upgrades and extras too (_gk_bundle).
   - Removing a single upgrade removes just that line.
   Works in the cart drawer and on the cart page, then asks the theme to
   rebuild the cart with its own "cart:build" event.
   ========================================================================== */
(function () {
  'use strict';
  if (window.__gkCart) return;
  window.__gkCart = true;

  var css = document.createElement('style');
  css.textContent =
    '.gk-cart-details{margin-top:4px}' +
    '.gk-cart-details summary{cursor:pointer;font-size:.85em;text-decoration:underline;text-underline-offset:3px;list-style:revert;margin-bottom:4px}' +
    '.gk-cart-details[open] summary{margin-bottom:6px}';
  document.head.appendChild(css);

  function routes() {
    var r = (window.theme && theme.routes) || {};
    return {
      cart: r.cart || '/cart.js',
      update: (r.cartPage || '/cart') + '/update.js',
      change: r.cartChange || '/cart/change.js'
    };
  }

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }

  function refresh() {
    document.dispatchEvent(new CustomEvent('cart:build'));
    if (document.body.classList.contains('template-cart') && !document.querySelector('[data-location="cart"], #CartPageForm')) {
      window.location.reload();
    }
  }

  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('[data-gk-remove]');
    if (!link) return;
    e.preventDefault();
    e.stopPropagation();

    var item = link.closest('.cart__item');
    if (item) item.classList.add('is-loading');
    var r = routes();
    var mode = link.getAttribute('data-gk-remove');
    var job;

    if (mode === 'bundle') {
      var bundle = link.getAttribute('data-gk-bundle');
      job = fetch(r.cart, { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          var updates = {};
          cart.items.forEach(function (it) {
            if (it.properties && it.properties._gk_bundle === bundle) updates[it.key] = 0;
          });
          updates[link.getAttribute('data-key')] = 0;
          return post(r.update, { updates: updates });
        });
    } else {
      // Removing one extra: also correct the kit's details it filled in (Mini Plates,
      // a paid print base or laminate), so the order never lists something unpaid.
      var key = link.getAttribute('data-key');
      job = fetch(r.cart, { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          var items = cart.items || [];
          var addon = items.filter(function (it) { return it.key === key; })[0];
          var ap = (addon && addon.properties) || {};
          var kit = addon && items.filter(function (it) {
            return it.properties && it.properties._gk_bundle === ap._gk_bundle && it.properties._gk_role === 'kit';
          })[0];
          var fixKit = Promise.resolve();
          if (kit) {
            var props = {}, changed = false;
            Object.keys(kit.properties).forEach(function (k) { props[k] = kit.properties[k]; });
            var fills = String(ap._gk_fills || '').split('|');
            var prop = fills[0], fallback = fills[1] || '', val = addon.product_title;
            // Carts made before this update: spot a mini plate pack by its title.
            if (!prop && props['Mini Plates'] && addon.product_title && props['Mini Plates'].indexOf(addon.product_title) !== -1) {
              prop = 'Mini Plates'; val = addon.product_title;
            }
            if (prop === 'Mini Plates' && props['Mini Plates']) {
              var left = props['Mini Plates'].replace(/\s*\(plus 3 free\)\s*$/, '').split(', ').filter(function (t) { return t && t !== val; });
              props['Mini Plates'] = left.length && left[0].indexOf('Each order') !== 0 ? left.join(', ') + ' (plus 3 free)' : 'Each order includes 3 free mini plates';
              changed = true;
            } else if (prop && fallback && props[prop] === val) {
              props[prop] = fallback;
              changed = true;
            }
            if (changed) {
              fixKit = post(r.change, { id: kit.key, quantity: kit.quantity, properties: props }).catch(function () {});
            }
          }
          return fixKit.then(function () { return post(r.change, { id: key, quantity: 0 }); });
        });
    }

    job.then(refresh).catch(function () {
      // Fall back to the plain Shopify link if anything goes wrong.
      window.location.href = link.href;
    });
  }, true);
})();